import React, { useState, useEffect } from "react";
import searchIcon from "../../../assets/search-new-icon.svg";
import CLOSE from "../../../assets/CLOSE.svg";

export default function InactiveDocumentTypeMappingModal({ onClose, onConfirm, procedures = [] }) {
  const list = procedures || [];
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState(new Set(list.map((_, i) => i)));

  useEffect(() => {
    setSelectedIds(new Set(list.map((_, i) => i)));
  }, [list.length]);

  const filteredWithIdx = list
    .map((item, idx) => ({ item, idx }))
    .filter(({ item }) =>
      (typeof item === "string" ? item : item.name || item.procedure || "").toLowerCase().includes((searchTerm.trim() || "").toLowerCase())
    );

  const totalCount = list.length;
  const allFilteredSelected =
    filteredWithIdx.length > 0 && filteredWithIdx.every(({ idx }) => selectedIds.has(idx));

  const toggleOne = (idx) => {
    const item = list[idx];
    const procSchemeId = item?.procedureSchemeId ?? item?.id;
    if (procSchemeId) {
      setSelectedIds((prev) => {
        const next = new Set(prev);
        const isSelected = prev.has(idx);
        list.forEach((p, i) => {
          const pid = p?.procedureSchemeId ?? p?.id;
          if (pid === procSchemeId) {
            if (isSelected) next.delete(i);
            else next.add(i);
          }
        });
        return next;
      });
    } else {
      setSelectedIds((prev) => {
        const next = new Set(prev);
        if (next.has(idx)) next.delete(idx);
        else next.add(idx);
        return next;
      });
    }
  };

  const toggleAll = () => {
    if (allFilteredSelected) {
      setSelectedIds((prev) => {
        const next = new Set(prev);
        filteredWithIdx.forEach(({ idx }) => next.delete(idx));
        return next;
      });
    } else {
      setSelectedIds((prev) => {
        const next = new Set(prev);
        filteredWithIdx.forEach(({ idx }) => next.add(idx));
        return next;
      });
    }
  };

  const getLabel = (item) =>
    typeof item === "string" ? item : (item.procedure ?? item.name ?? "");

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm cursor-pointer"
      style={{ backgroundColor: "#017C71B2" }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-h-[90vh] flex flex-col overflow-hidden cursor-default"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-end p-4 pb-0">
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-black"
          >
            <img src={CLOSE} alt="close" className="w-5 h-5" />
          </button>
        </div>

        <h2 className="font-lufga text-xl font-semibold text-center px-6 pb-2">
          Do you want to inactive Document Type Mapping?
        </h2>

        <div className="px-6 pb-4">
          <div className="flex items-center justify-between mb-3">
            <span className="font-lufga font-semibold text-[#1B1B1B]">
              It will impact on the below Mapped Procedures
            </span>
            <span className="font-lufga text-[#5AC69F] font-medium">
              Total Mapped Procedures ({String(totalCount).padStart(2, "0")})
            </span>
          </div>

          <div className="relative mb-4">
            <img
              src={searchIcon}
              alt="search"
              className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none"
            />
            <input
              type="text"
              placeholder="Procedure Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full h-12 pl-11 pr-4 border border-[#E0E0E0] rounded-full outline-none font-lufga text-sm text-[#1B1B1B] placeholder:text-gray-400 bg-white"
            />
          </div>

          <div className="border border-[#E0E0E0] rounded-2xl overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-[#E0E0E0]">
              <span className="font-lufga font-semibold text-sm text-[#1B1B1B]">
                Mapped Procedure Name
              </span>
              <button
                type="button"
                onClick={toggleAll}
                className="font-lufga text-sm font-medium text-[#5AC69F] flex items-center gap-2"
              >
                <span className="w-5 h-5 rounded-full border-2 border-[#5AC69F] flex items-center justify-center">
                  {allFilteredSelected ? (
                    <span className="text-[#5AC69F] text-sm">✓</span>
                  ) : null}
                </span>
                Select All
              </button>
            </div>

            <div className="max-h-[240px] overflow-y-auto">
              {filteredWithIdx.length === 0 ? (
                <div className="px-4 py-6 text-center text-gray-500 font-lufga text-sm">
                  No procedures found
                </div>
              ) : (
                filteredWithIdx.map(({ item, idx }) => {
                  const isSelected = selectedIds.has(idx);
                  const label = getLabel(item);
                  return (
                    <div
                      key={idx}
                      onClick={() => toggleOne(idx)}
                      className="flex items-center gap-3 px-4 py-3 hover:bg-[#F4FBF8] cursor-pointer border-b border-[#E8E8E8] last:border-b-0"
                    >
                      <span
                        className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                          isSelected
                            ? "border-[#5AC69F] bg-[#5AC69F]"
                            : "border-gray-300 bg-white"
                        }`}
                      >
                        {isSelected && (
                          <span className="text-white text-xs font-bold">✓</span>
                        )}
                      </span>
                      <span className="font-lufga text-sm text-[#1B1B1B] break-words">
                        {label}
                      </span>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>

        <div className="px-6 pb-6 pt-2 flex justify-center">
          <button
            onClick={async () => {
              const selectedProcedures = [...selectedIds].map((idx) => list[idx]).filter(Boolean);
              console.log("InactiveDocumentTypeMappingModal - selectedProcedures on Yes click:", selectedProcedures);
              await onConfirm?.(selectedProcedures);
              onClose?.();
            }}
            className="w-[380px] h-[88px] px-[20px] py-[20px] gap-[20px] rounded-[60px] border-2 border-[#5AC69F] font-lufga font-medium text-[16px] leading-[155%] text-black bg-[#5AC69F] hover:bg-[#4AB88E] transition flex items-center justify-center"
          >
            Yes, Inactive Document Type Mapping
          </button>
        </div>
      </div>
    </div>
  );
}
